export { default } from './MenuPromotionProductCard'
